var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('b-container', {
    attrs: {
      "fluid": ""
    }
  }, [_c('b-row', [_c('b-col', {
    attrs: {
      "lg": "6",
      "sm": "12"
    }
  }, [_c('iq-card', {
    scopedSlots: _vm._u([{
      key: "headerTitle",
      fn: function fn() {
        return [_c('h4', {
          staticClass: "card-title"
        }, [_vm._v("Badges")])];
      },
      proxy: true
    }, {
      key: "headerAction",
      fn: function fn() {
        return [_c('a', {
          directives: [{
            name: "b-toggle",
            rawName: "v-b-toggle.collapse-1",
            modifiers: {
              "collapse-1": true
            }
          }],
          staticClass: "text-primary float-right",
          attrs: {
            "role": "button"
          }
        }, [_c('i', {
          staticClass: "ri-code-s-slash-line"
        })])];
      },
      proxy: true
    }, {
      key: "body",
      fn: function fn() {
        return [_c('p', [_vm._v("Badges scale to match the size of the immediate parent element by using relative font sizing and "), _c('code', [_vm._v("em")]), _vm._v(" units.")]), _c('b-collapse', {
          staticClass: "mb-2",
          attrs: {
            "id": "collapse-1"
          }
        }, [_c('div', {
          staticClass: "card"
        }, [_c('kbd', {
          staticClass: "bg-dark"
        }, [_c('pre', {
          staticClass: "text-white",
          attrs: {
            "id": "badges"
          }
        }, [_vm._v("                    "), _c('code', [_vm._v("\n<h1 class=\"mb-3\">Example heading <b-badge variant=\"primary\">New</b-badge></h1>\n<h2 class=\"mb-3\">Example heading <b-badge variant=\"secondary\">New</b-badge></h2>\n<h3 class=\"mb-3\">Example heading <b-button variant=\"success\">\n  Notifications <b-badge variant=\"light\" class=\"ml-2\">4</b-badge>\n</b-button></h3>\n<h4 class=\"mb-3\">Example heading <b-badge variant=\"danger\">New</b-badge></h4>\n<h5 class=\"mb-3\">Example heading <b-badge variant=\"warning\">New</b-badge></h5>\n<h6 class=\"mb-0\">Example heading <b-badge variant=\"info\">New</b-badge></h6>\n")])])])])]), _c('h1', {
          staticClass: "mb-3"
        }, [_vm._v("Example heading "), _c('b-badge', {
          attrs: {
            "variant": "primary"
          }
        }, [_vm._v("New")])], 1), _c('h2', {
          staticClass: "mb-3"
        }, [_vm._v("Example heading "), _c('b-badge', {
          attrs: {
            "variant": "secondary"
          }
        }, [_vm._v("New")])], 1), _c('h3', {
          staticClass: "mb-3"
        }, [_vm._v("Example heading "), _c('b-button', {
          attrs: {
            "variant": "success"
          }
        }, [_vm._v(" Notifications "), _c('b-badge', {
          staticClass: "ml-2",
          attrs: {
            "variant": "light"
          }
        }, [_vm._v("4")])], 1)], 1), _c('h4', {
          staticClass: "mb-3"
        }, [_vm._v("Example heading "), _c('b-badge', {
          attrs: {
            "variant": "danger"
          }
        }, [_vm._v("New")])], 1), _c('h5', {
          staticClass: "mb-3"
        }, [_vm._v("Example heading "), _c('b-badge', {
          attrs: {
            "variant": "warning"
          }
        }, [_vm._v("New")])], 1), _c('h6', {
          staticClass: "mb-0"
        }, [_vm._v("Example heading "), _c('b-badge', {
          attrs: {
            "variant": "info"
          }
        }, [_vm._v("New")])], 1)];
      },
      proxy: true
    }])
  }), _c('iq-card', {
    scopedSlots: _vm._u([{
      key: "headerTitle",
      fn: function fn() {
        return [_c('h4', {
          staticClass: "card-title"
        }, [_vm._v("Button Badges")])];
      },
      proxy: true
    }, {
      key: "headerAction",
      fn: function fn() {
        return [_c('a', {
          directives: [{
            name: "b-toggle",
            rawName: "v-b-toggle.collapse-2",
            modifiers: {
              "collapse-2": true
            }
          }],
          staticClass: "text-primary float-right",
          attrs: {
            "role": "button"
          }
        }, [_c('i', {
          staticClass: "ri-code-s-slash-line"
        })])];
      },
      proxy: true
    }, {
      key: "body",
      fn: function fn() {
        return [_c('p', [_vm._v("Badges can be used as part of buttons to provide a counter.")]), _c('b-collapse', {
          staticClass: "mb-2",
          attrs: {
            "id": "collapse-2"
          }
        }, [_c('div', {
          staticClass: "card"
        }, [_c('kbd', {
          staticClass: "bg-dark"
        }, [_c('pre', {
          staticClass: "text-white",
          attrs: {
            "id": "button-badges"
          }
        }, [_vm._v("                    "), _c('code', [_vm._v("\n<b-button variant=\"primary\" class=\"mb-1\">\n  Notifications <b-badge variant=\"light\" class=\"ml-2\">4</b-badge>\n</b-button>\n<b-button variant=\"success\" class=\"mb-1\">\n  Notifications<b-badge variant=\"light\" class=\"ml-2\">4</b-badge>\n</b-button>\n<b-button variant=\"danger\" class=\"mb-1\">\n  Notifications<b-badge variant=\"light\" class=\"ml-2\">4</b-badge>\n</b-button>\n")])])])])]), _c('b-button', {
          staticClass: "mb-1 mr-1",
          attrs: {
            "variant": "primary"
          }
        }, [_vm._v(" Notifications "), _c('b-badge', {
          staticClass: "ml-2",
          attrs: {
            "variant": "light"
          }
        }, [_vm._v("4")])], 1), _c('b-button', {
          staticClass: "mb-1 mr-1",
          attrs: {
            "variant": "success"
          }
        }, [_vm._v(" Notifications"), _c('b-badge', {
          staticClass: "ml-2",
          attrs: {
            "variant": "light"
          }
        }, [_vm._v("4")])], 1), _c('b-button', {
          staticClass: "mb-1 mr-1",
          attrs: {
            "variant": "danger"
          }
        }, [_vm._v(" Notifications"), _c('b-badge', {
          staticClass: "ml-2",
          attrs: {
            "variant": "light"
          }
        }, [_vm._v("4")])], 1)];
      },
      proxy: true
    }])
  }), _c('iq-card', {
    scopedSlots: _vm._u([{
      key: "headerTitle",
      fn: function fn() {
        return [_c('h4', {
          staticClass: "card-title"
        }, [_vm._v("Button Light background Badges")])];
      },
      proxy: true
    }, {
      key: "headerAction",
      fn: function fn() {
        return [_c('a', {
          directives: [{
            name: "b-toggle",
            rawName: "v-b-toggle.collapse-3",
            modifiers: {
              "collapse-3": true
            }
          }],
          staticClass: "text-primary float-right",
          attrs: {
            "role": "button"
          }
        }, [_c('i', {
          staticClass: "ri-code-s-slash-line"
        })])];
      },
      proxy: true
    }, {
      key: "body",
      fn: function fn() {
        return [_c('p', [_vm._v("Badges can be used as part of buttons to provide a counter.")]), _c('b-collapse', {
          staticClass: "mb-2",
          attrs: {
            "id": "collapse-3"
          }
        }, [_c('div', {
          staticClass: "card"
        }, [_c('kbd', {
          staticClass: "bg-dark"
        }, [_c('pre', {
          staticClass: "text-white",
          attrs: {
            "id": "button-light-background-badges"
          }
        }, [_vm._v("                    "), _c('code', [_vm._v("\n<b-button variant=\"outline-primary\" class=\"mb-1\">\n  Notifications <b-badge variant=\"primary\" class=\"ml-2\">4</b-badge>\n</b-button>\n<b-button variant=\"outline-success\" class=\"mb-1\">\n  Notifications<b-badge variant=\"success\" class=\"ml-2\">4</b-badge>\n</b-button>\n<b-button variant=\"outline-danger\" class=\"mb-1\">\n  Notifications<b-badge variant=\"danger\" class=\"ml-2\">4</b-badge>\n</b-button>\n")])])])])]), _c('b-button', {
          staticClass: "mb-1 mr-1",
          attrs: {
            "variant": "outline-primary"
          }
        }, [_vm._v(" Notifications "), _c('b-badge', {
          staticClass: "ml-2",
          attrs: {
            "variant": "primary"
          }
        }, [_vm._v("4")])], 1), _c('b-button', {
          staticClass: "mb-1 mr-1",
          attrs: {
            "variant": "outline-success"
          }
        }, [_vm._v(" Notifications"), _c('b-badge', {
          staticClass: "ml-2",
          attrs: {
            "variant": "success"
          }
        }, [_vm._v("4")])], 1), _c('b-button', {
          staticClass: "mb-1 mr-1",
          attrs: {
            "variant": "outline-danger"
          }
        }, [_vm._v(" Notifications"), _c('b-badge', {
          staticClass: "ml-2",
          attrs: {
            "variant": "danger"
          }
        }, [_vm._v("4")])], 1)];
      },
      proxy: true
    }])
  }), _c('iq-card', {
    scopedSlots: _vm._u([{
      key: "headerTitle",
      fn: function fn() {
        return [_c('h4', {
          staticClass: "card-title"
        }, [_vm._v("Button Border Badges")])];
      },
      proxy: true
    }, {
      key: "headerAction",
      fn: function fn() {
        return [_c('a', {
          directives: [{
            name: "b-toggle",
            rawName: "v-b-toggle.collapse-4",
            modifiers: {
              "collapse-4": true
            }
          }],
          staticClass: "text-primary float-right",
          attrs: {
            "role": "button"
          }
        }, [_c('i', {
          staticClass: "ri-code-s-slash-line"
        })])];
      },
      proxy: true
    }, {
      key: "body",
      fn: function fn() {
        return [_c('p', [_vm._v("Badges can be used as part of buttons to provide a counter.")]), _c('b-collapse', {
          staticClass: "mb-2",
          attrs: {
            "id": "collapse-4"
          }
        }, [_c('div', {
          staticClass: "card"
        }, [_c('kbd', {
          staticClass: "bg-dark"
        }, [_c('pre', {
          staticClass: "text-white",
          attrs: {
            "id": "button-border-badges"
          }
        }, [_vm._v("                    "), _c('code', [_vm._v("\n<b-button variant=\"none\" class=\"iq-bg-primary mb-1\">\n  Notifications <b-badge variant=\"primary\" class=\"ml-2\">4</b-badge>\n</b-button>\n<b-button variant=\"none\" class=\"iq-bg-success mb-1\">\n  Notifications<b-badge variant=\"success\" class=\"ml-2\">4</b-badge>\n</b-button>\n<b-button variant=\"none\" class=\"iq-bg-danger mb-1\">\n  Notifications<b-badge variant=\"danger\" class=\"ml-2\">4</b-badge>\n</b-button>\n")])])])])]), _c('b-button', {
          staticClass: "iq-bg-primary mb-1 mr-1",
          attrs: {
            "variant": "none"
          }
        }, [_vm._v(" Notifications "), _c('b-badge', {
          staticClass: "ml-2",
          attrs: {
            "variant": "primary"
          }
        }, [_vm._v("4")])], 1), _c('b-button', {
          staticClass: "iq-bg-success mb-1 mr-1",
          attrs: {
            "variant": "none"
          }
        }, [_vm._v(" Notifications"), _c('b-badge', {
          staticClass: "ml-2",
          attrs: {
            "variant": "success"
          }
        }, [_vm._v("4")])], 1), _c('b-button', {
          staticClass: "iq-bg-danger mb-1 mr-1",
          attrs: {
            "variant": "none"
          }
        }, [_vm._v(" Notifications"), _c('b-badge', {
          staticClass: "ml-2",
          attrs: {
            "variant": "danger"
          }
        }, [_vm._v("4")])], 1)];
      },
      proxy: true
    }])
  })], 1), _c('b-col', {
    attrs: {
      "lg": "6",
      "sm": "12"
    }
  }, [_c('iq-card', {
    scopedSlots: _vm._u([{
      key: "headerTitle",
      fn: function fn() {
        return [_c('h4', {
          staticClass: "card-title"
        }, [_vm._v("Contextual variations")])];
      },
      proxy: true
    }, {
      key: "headerAction",
      fn: function fn() {
        return [_c('a', {
          directives: [{
            name: "b-toggle",
            rawName: "v-b-toggle.collapse-5",
            modifiers: {
              "collapse-5": true
            }
          }],
          staticClass: "text-primary float-right",
          attrs: {
            "role": "button"
          }
        }, [_c('i', {
          staticClass: "ri-code-s-slash-line"
        })])];
      },
      proxy: true
    }, {
      key: "body",
      fn: function fn() {
        return [_c('p', [_vm._v("Add any of the below mentioned modifier classes to change the appearance of a badge.")]), _c('b-collapse', {
          staticClass: "mb-2",
          attrs: {
            "id": "collapse-5"
          }
        }, [_c('div', {
          staticClass: "card"
        }, [_c('kbd', {
          staticClass: "bg-dark"
        }, [_c('pre', {
          staticClass: "text-white",
          attrs: {
            "id": "contextual-variations"
          }
        }, [_vm._v("                    "), _c('code', [_vm._v("\n<b-badge variant=\"primary\">Primary</b-badge>\n<b-badge variant=\"secondary\">Secondary</b-badge>\n<b-badge variant=\"success\">Success</b-badge>\n<b-badge variant=\"danger\">Danger</b-badge>\n<b-badge variant=\"warning\">Warning</b-badge>\n<b-badge variant=\"info\">Info</b-badge>\n<b-badge variant=\"light\">Light</b-badge>\n<b-badge variant=\"dark\">Dark</b-badge>\n\n<h5 class=\"card-title mt-4\">Pill badges</h5>\n<p>Use the <code>.badge-pill</code> modifier class to make badges more rounded (with a larger <code>border-radius</code> and additional horizontal <code>padding</code>). Useful if you miss the badges from v3.</p>\n\n<b-badge pill variant=\"primary\">Primary</b-badge>\n<b-badge pill variant=\"secondary\">Secondary</b-badge>\n<b-badge pill variant=\"success\">Success</b-badge>\n<b-badge pill variant=\"danger\">Danger</b-badge>\n<b-badge pill variant=\"warning\">Warning</b-badge>\n<b-badge pill variant=\"info\">Info</b-badge>\n<b-badge pill variant=\"light\">Light</b-badge>\n<b-badge pill variant=\"dark\">Dark</b-badge>\n\n<h5 class=\"card-title mt-4\">Links</h5>\n<p>Using the contextual <code>.badge-*</code> classes on an <code>&lt;a&gt;</code> element quickly provide <em>actionable</em> badges with hover and focus states.</p>\n\n<b-badge href=\"#\" variant=\"primary\">Primary</b-badge>\n<b-badge href=\"#\" variant=\"secondary\">Secondary</b-badge>\n<b-badge href=\"#\" variant=\"success\">Success</b-badge>\n<b-badge href=\"#\" variant=\"danger\">Danger</b-badge>\n<b-badge href=\"#\" variant=\"warning\">Warning</b-badge>\n<b-badge href=\"#\" variant=\"info\">Info</b-badge>\n<b-badge href=\"#\" variant=\"light\">Light</b-badge>\n<b-badge href=\"#\" variant=\"dark\">Dark</b-badge>\n")])])])])]), _c('b-badge', {
          staticClass: "mr-1",
          attrs: {
            "variant": "primary"
          }
        }, [_vm._v("Primary")]), _c('b-badge', {
          staticClass: "mr-1",
          attrs: {
            "variant": "secondary"
          }
        }, [_vm._v("Secondary")]), _c('b-badge', {
          staticClass: "mr-1",
          attrs: {
            "variant": "success"
          }
        }, [_vm._v("Success")]), _c('b-badge', {
          staticClass: "mr-1",
          attrs: {
            "variant": "danger"
          }
        }, [_vm._v("Danger")]), _c('b-badge', {
          staticClass: "mr-1",
          attrs: {
            "variant": "warning"
          }
        }, [_vm._v("Warning")]), _c('b-badge', {
          staticClass: "mr-1",
          attrs: {
            "variant": "info"
          }
        }, [_vm._v("Info")]), _c('b-badge', {
          staticClass: "mr-1",
          attrs: {
            "variant": "light"
          }
        }, [_vm._v("Light")]), _c('b-badge', {
          staticClass: "mr-1",
          attrs: {
            "variant": "dark"
          }
        }, [_vm._v("Dark")]), _c('h5', {
          staticClass: "card-title mt-4"
        }, [_vm._v("Pill badges")]), _c('p', [_vm._v("Use the "), _c('code', [_vm._v(".badge-pill")]), _vm._v(" modifier class to make badges more rounded (with a larger "), _c('code', [_vm._v("border-radius")]), _vm._v(" and additional horizontal "), _c('code', [_vm._v("padding")]), _vm._v("). Useful if you miss the badges from v3.")]), _c('b-badge', {
          staticClass: "mr-1",
          attrs: {
            "pill": "",
            "variant": "primary"
          }
        }, [_vm._v("Primary")]), _c('b-badge', {
          staticClass: "mr-1",
          attrs: {
            "pill": "",
            "variant": "secondary"
          }
        }, [_vm._v("Secondary")]), _c('b-badge', {
          staticClass: "mr-1",
          attrs: {
            "pill": "",
            "variant": "success"
          }
        }, [_vm._v("Success")]), _c('b-badge', {
          staticClass: "mr-1",
          attrs: {
            "pill": "",
            "variant": "danger"
          }
        }, [_vm._v("Danger")]), _c('b-badge', {
          staticClass: "mr-1",
          attrs: {
            "pill": "",
            "variant": "warning"
          }
        }, [_vm._v("Warning")]), _c('b-badge', {
          staticClass: "mr-1",
          attrs: {
            "pill": "",
            "variant": "info"
          }
        }, [_vm._v("Info")]), _c('b-badge', {
          staticClass: "mr-1",
          attrs: {
            "pill": "",
            "variant": "light"
          }
        }, [_vm._v("Light")]), _c('b-badge', {
          staticClass: "mr-1",
          attrs: {
            "pill": "",
            "variant": "dark"
          }
        }, [_vm._v("Dark")]), _c('h5', {
          staticClass: "card-title mt-4"
        }, [_vm._v("Links")]), _c('p', [_vm._v("Using the contextual "), _c('code', [_vm._v(".badge-*")]), _vm._v(" classes on an "), _c('code', [_vm._v("<a>")]), _vm._v(" element quickly provide "), _c('em', [_vm._v("actionable")]), _vm._v(" badges with hover and focus states.")]), _c('b-badge', {
          staticClass: "mr-1",
          attrs: {
            "href": "#",
            "variant": "primary"
          }
        }, [_vm._v("Primary")]), _c('b-badge', {
          staticClass: "mr-1",
          attrs: {
            "href": "#",
            "variant": "secondary"
          }
        }, [_vm._v("Secondary")]), _c('b-badge', {
          staticClass: "mr-1",
          attrs: {
            "href": "#",
            "variant": "success"
          }
        }, [_vm._v("Success")]), _c('b-badge', {
          staticClass: "mr-1",
          attrs: {
            "href": "#",
            "variant": "danger"
          }
        }, [_vm._v("Danger")]), _c('b-badge', {
          staticClass: "mr-1",
          attrs: {
            "href": "#",
            "variant": "warning"
          }
        }, [_vm._v("Warning")]), _c('b-badge', {
          staticClass: "mr-1",
          attrs: {
            "href": "#",
            "variant": "info"
          }
        }, [_vm._v("Info")]), _c('b-badge', {
          staticClass: "mr-1",
          attrs: {
            "href": "#",
            "variant": "light"
          }
        }, [_vm._v("Light")]), _c('b-badge', {
          staticClass: "mr-1",
          attrs: {
            "href": "#",
            "variant": "dark"
          }
        }, [_vm._v("Dark")])];
      },
      proxy: true
    }])
  }), _c('iq-card', {
    scopedSlots: _vm._u([{
      key: "headerTitle",
      fn: function fn() {
        return [_c('h4', {
          staticClass: "card-title"
        }, [_vm._v("Contextual variations Border")])];
      },
      proxy: true
    }, {
      key: "headerAction",
      fn: function fn() {
        return [_c('a', {
          directives: [{
            name: "b-toggle",
            rawName: "v-b-toggle.collapse-6",
            modifiers: {
              "collapse-6": true
            }
          }],
          staticClass: "text-primary float-right",
          attrs: {
            "role": "button"
          }
        }, [_c('i', {
          staticClass: "ri-code-s-slash-line"
        })])];
      },
      proxy: true
    }, {
      key: "body",
      fn: function fn() {
        return [_c('p', [_vm._v("Add any of the below mentioned modifier classes to change the appearance of a badge.")]), _c('b-collapse', {
          staticClass: "mb-2",
          attrs: {
            "id": "collapse-6"
          }
        }, [_c('div', {
          staticClass: "card"
        }, [_c('kbd', {
          staticClass: "bg-dark"
        }, [_c('pre', {
          staticClass: "text-white",
          attrs: {
            "id": "contextual-variations-border"
          }
        }, [_vm._v("                    "), _c('code', [_vm._v("\n<b-badge class=\"border border-primary text-primary\" variant=\"none\">Primary</b-badge>\n<b-badge class=\"border border-secondary text-secondary\" variant=\"none\">Secondary</b-badge>\n<b-badge class=\"border border-success text-success\" variant=\"none\">Success</b-badge>\n<b-badge class=\"border border-danger text-danger\" variant=\"none\">Danger</b-badge>\n<b-badge class=\"border border-warning text-warning\" variant=\"none\">Warning</b-badge>\n<b-badge class=\"border border-info text-info\" variant=\"none\">Info</b-badge>\n<b-badge class=\"border border-light text-light\" variant=\"none\">Light</b-badge>\n<b-badge class=\"border border-dark text-dark\" variant=\"none\">Dark</b-badge>\n\n<h5 class=\"card-title mt-4\">Pill badges</h5>\n<p>Use the <code>.badge-pill</code> modifier class to make badges more rounded (with a larger <code>border-radius</code> and additional horizontal <code>padding</code>). Useful if you miss the badges from v3.</p>\n<b-badge class=\"border border-primary text-primary\" pill variant=\"none\">Primary</b-badge>\n<b-badge class=\"border border-secondary text-secondary\" pill variant=\"none\">Secondary</b-badge>\n<b-badge class=\"border border-success text-success\" pill variant=\"none\">Success</b-badge>\n<b-badge class=\"border border-danger text-danger\" pill variant=\"none\">Danger</b-badge>\n<b-badge class=\"border border-warning text-warning\" pill variant=\"none\">Warning</b-badge>\n<b-badge class=\"border border-info text-info\" pill variant=\"none\">Info</b-badge>\n<b-badge class=\"border border-light text-light\" pill variant=\"none\">Light</b-badge>\n<b-badge class=\"border border-dark text-dark\" pill variant=\"none\">Dark</b-badge>\n\n<h5 class=\"card-title mt-4\">Links</h5>\n<p>Using the contextual <code>.badge-*</code> classes on an <code>&lt;a&gt;</code> element quickly provide <em>actionable</em> badges with hover and focus states.</p>\n<b-badge href=\"#\" class=\"border border-primary text-primary\" variant=\"none\">Primary</b-badge>\n<b-badge href=\"#\" class=\"border border-secondary text-secondary\" variant=\"none\">Secondary</b-badge>\n<b-badge href=\"#\" class=\"border border-success text-success\" variant=\"none\">Success</b-badge>\n<b-badge href=\"#\" class=\"border border-danger text-danger\" variant=\"none\">Danger</b-badge>\n<b-badge href=\"#\" class=\"border border-warning text-warning\" variant=\"none\">Warning</b-badge>\n<b-badge href=\"#\" class=\"border border-info text-info\" variant=\"none\">Info</b-badge>\n<b-badge href=\"#\" class=\"border border-light text-light\" variant=\"none\">Light</b-badge>\n<b-badge href=\"#\" class=\"border border-dark text-dark\" variant=\"none\">Dark</b-badge>\n")])])])])]), _c('b-badge', {
          staticClass: "border border-primary text-primary mr-1",
          attrs: {
            "variant": "none"
          }
        }, [_vm._v("Primary")]), _c('b-badge', {
          staticClass: "border border-secondary text-secondary mr-1",
          attrs: {
            "variant": "none"
          }
        }, [_vm._v("Secondary")]), _c('b-badge', {
          staticClass: "border border-success text-success mr-1",
          attrs: {
            "variant": "none"
          }
        }, [_vm._v("Success")]), _c('b-badge', {
          staticClass: "border border-danger text-danger mr-1",
          attrs: {
            "variant": "none"
          }
        }, [_vm._v("Danger")]), _c('b-badge', {
          staticClass: "border border-warning text-warning mr-1",
          attrs: {
            "variant": "none"
          }
        }, [_vm._v("Warning")]), _c('b-badge', {
          staticClass: "border border-info text-info mr-1",
          attrs: {
            "variant": "none"
          }
        }, [_vm._v("Info")]), _c('b-badge', {
          staticClass: "border border-light text-light mr-1",
          attrs: {
            "variant": "none"
          }
        }, [_vm._v("Light")]), _c('b-badge', {
          staticClass: "border border-dark text-dark mr-1",
          attrs: {
            "variant": "none"
          }
        }, [_vm._v("Dark")]), _c('h5', {
          staticClass: "card-title mt-4"
        }, [_vm._v("Pill badges")]), _c('p', [_vm._v("Use the "), _c('code', [_vm._v(".badge-pill")]), _vm._v(" modifier class to make badges more rounded (with a larger "), _c('code', [_vm._v("border-radius")]), _vm._v(" and additional horizontal "), _c('code', [_vm._v("padding")]), _vm._v("). Useful if you miss the badges from v3.")]), _c('b-badge', {
          staticClass: "border border-primary text-primary mr-1",
          attrs: {
            "pill": "",
            "variant": "none"
          }
        }, [_vm._v("Primary")]), _c('b-badge', {
          staticClass: "border border-secondary text-secondary mr-1",
          attrs: {
            "pill": "",
            "variant": "none"
          }
        }, [_vm._v("Secondary")]), _c('b-badge', {
          staticClass: "border border-success text-success mr-1",
          attrs: {
            "pill": "",
            "variant": "none"
          }
        }, [_vm._v("Success")]), _c('b-badge', {
          staticClass: "border border-danger text-danger mr-1",
          attrs: {
            "pill": "",
            "variant": "none"
          }
        }, [_vm._v("Danger")]), _c('b-badge', {
          staticClass: "border border-warning text-warning mr-1",
          attrs: {
            "pill": "",
            "variant": "none"
          }
        }, [_vm._v("Warning")]), _c('b-badge', {
          staticClass: "border border-info text-info mr-1",
          attrs: {
            "pill": "",
            "variant": "none"
          }
        }, [_vm._v("Info")]), _c('b-badge', {
          staticClass: "border border-light text-light mr-1",
          attrs: {
            "pill": "",
            "variant": "none"
          }
        }, [_vm._v("Light")]), _c('b-badge', {
          staticClass: "border border-dark text-dark mr-1",
          attrs: {
            "pill": "",
            "variant": "none"
          }
        }, [_vm._v("Dark")]), _c('h5', {
          staticClass: "card-title mt-4"
        }, [_vm._v("Links")]), _c('p', [_vm._v("Using the contextual "), _c('code', [_vm._v(".badge-*")]), _vm._v(" classes on an "), _c('code', [_vm._v("<a>")]), _vm._v(" element quickly provide "), _c('em', [_vm._v("actionable")]), _vm._v(" badges with hover and focus states.")]), _c('b-badge', {
          staticClass: "border border-primary text-primary mr-1",
          attrs: {
            "href": "#",
            "variant": "none"
          }
        }, [_vm._v("Primary")]), _c('b-badge', {
          staticClass: "border border-secondary text-secondary mr-1",
          attrs: {
            "href": "#",
            "variant": "none"
          }
        }, [_vm._v("Secondary")]), _c('b-badge', {
          staticClass: "border border-success text-success mr-1",
          attrs: {
            "href": "#",
            "variant": "none"
          }
        }, [_vm._v("Success")]), _c('b-badge', {
          staticClass: "border border-danger text-danger mr-1",
          attrs: {
            "href": "#",
            "variant": "none"
          }
        }, [_vm._v("Danger")]), _c('b-badge', {
          staticClass: "border border-warning text-warning mr-1",
          attrs: {
            "href": "#",
            "variant": "none"
          }
        }, [_vm._v("Warning")]), _c('b-badge', {
          staticClass: "border border-info text-info mr-1",
          attrs: {
            "href": "#",
            "variant": "none"
          }
        }, [_vm._v("Info")]), _c('b-badge', {
          staticClass: "border border-light text-light mr-1",
          attrs: {
            "href": "#",
            "variant": "none"
          }
        }, [_vm._v("Light")]), _c('b-badge', {
          staticClass: "border border-dark text-dark mr-1",
          attrs: {
            "href": "#",
            "variant": "none"
          }
        }, [_vm._v("Dark")])];
      },
      proxy: true
    }])
  })], 1)], 1)], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }